$('.js-nav-dashboard a').on('click', function (e) {
	if ($(window).width() <= 767) {
		e.preventDefault();

		$('.js-widget-dashboard').toggleClass('is-expanded');
	}
});
